import AppTranslation, { AppTranslationMessage } from "../../../app/AppTranslation";

enum StvTitel {
    KEIN_TITEL = "KEIN_TITEL",
    DR = "DR",
    DR_DR = "DR_DR",
    PROF = "PROF",
    PROF_DR = "PROF_DR",
    DR_MED = "DR_MED"
}

export function getFormText(value: StvTitel) {
    return AppTranslation.getMessage(AppTranslationMessage.APP_MODEL_TITEL_FORM, value);
}


export default StvTitel;